import { apiClient } from './apiClient';

const createCommand = async (payload) => {
  return await apiClient.post('/dashboard/command', payload);
};

const fetchCommands = async (payload) => {
  return await apiClient.get('/dashboard/commands', payload);
};

const updateCommand = async (id, payload) => {
  return await apiClient.patch(`/dashboard/command/${id}`, payload);
};

const deleteCommand = async (id) => {
  return await apiClient.delete_req(`/dashboard/command/${id}`);
};

export const commandApi = {
  createCommand,
  fetchCommands,
  updateCommand,
  deleteCommand
};
